import { render } from "./homeTeacherTrain.vue?vue&type=template&id=3bf1c199&scoped=true"
import script from "./homeTeacherTrain.vue?vue&type=script&lang=js"
export * from "./homeTeacherTrain.vue?vue&type=script&lang=js"

import "./homeTeacherTrain.vue?vue&type=style&index=0&id=3bf1c199&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf1c199"]])

export default __exports__